
export interface FeedBackDetails {
	assignedTo: User
	attachments: Array<string>
	createdAt:  string | number | Date
	createdBy: User
	description: string
	feedbackType: FeedbackTypes
	id: string
	message: string
	repliedAt: string | number | Date
	repliedBy: User
	resourceReported: {
		resourceType: string
		title: string
	}
	shortDescription: string
	state: string
	status: string
	topics: Array<string>
	userReported: User
}

export interface User {
	firstName: string
	imageId: string
	isActive: boolean
	isDeleted: boolean
	lastName: string
	location: string
	reinvite: boolean
	rocketUserId: string
	role: string
	userId: string
}

export enum FeedbackTypes {
	BugReport = 'BugReport',
	FlagOfAbuse = 'FlagOfAbuse',
	GeneralFeedback = 'GeneralFeedback',
	Help = 'Help',
	VideoFeedback = 'VideoFeedback'
}
